import { CookieConsent } from '../model/cookie-consent.types';


export const COOKIE_CONSENT_NAME = 'cookie_consent';

export const COOKIE_CONSENT_VERSION = 2;

export const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

export const DEFAULT_COOKIE_CONSENT: CookieConsent = {
    version  : COOKIE_CONSENT_VERSION,
    necessary: true,
    analytics: false,
};

export const ACCEPT_ALL_COOKIE_CONSENT: CookieConsent = {
    version  : COOKIE_CONSENT_VERSION,
    necessary: true,
    analytics: true,
};
